<div class="footer">
    <div class="footer-content">
        <div class="footer-content-social col-sm-12 col-md-12">
            <div class="d-flex">
                <a href="https://www.twitch.tv/playforgood_" target="_blank">
                    <div class="container-logo icon-twitch">
                        <fa-icon [icon]="faTwitch" size="lg"></fa-icon>
                    </div>
                </a>
                <a href="https://twitter.com/PlayForGood_" target="_blank">
                    <div class="container-logo icon-twitter">
                        <fa-icon [icon]="faTwitter" size="lg"></fa-icon>
                    </div>
                </a>
                <a href="https://www.instagram.com/playforgood_/" target="_blank">
                    <div class="container-logo icon-insta">
                        <fa-icon [icon]="faInstagram" size="lg"></fa-icon>
                    </div>
                </a>
                <a href="https://www.facebook.com/pulsimpact/" target="_blank">
                    <div class="container-logo icon-fb">
                        <fa-icon [icon]="faFacebook" size="lg"></fa-icon>
                    </div>
                </a>
                <a href="https://www.linkedin.com/company/73048349" target="_blank">
                    <div class="container-logo icon-linkedin">
                        <fa-icon [icon]="faLinkedin" size="lg"></fa-icon>
                    </div>
                </a>
                <a href="https://discord.gg/GAAm4Fdtx9" target="_blank">
                    <div class="container-logo icon-discord">
                        <fa-icon [icon]="faDiscord" size="lg"></fa-icon>
                    </div>
                </a>
            </div>
        </div>
        <div class="footer-content-legals col-sm-12 col-md-12">
            <div>
                <span>PLAY FOR GOOD © 2021 -
                    <a href="https://playforgood.io/mentions-legales/" target="_blank">Mentions légales</a> -
                    <a href="https://playforgood.io/politique-de-confidentialite/" target="_blank">Politique de confidentialité</a>
                </span>
            </div>
        </div>
    </div>
</div>
